import { clsx } from 'clsx';
import { type ComponentPropsWithoutRef, forwardRef, type ReactNode } from 'react';
import { IconSearch } from '@optiaxiom/icons';
import { Input } from '@optiaxiom/react';

import * as styles from './spotlight.css';

export type SpotlightInputProps = Omit<ComponentPropsWithoutRef<typeof Input>, 'size'> & {
  /** Leading adornment; defaults to a search icon. */
  addonBefore?: ReactNode;
};

/**
 * The Spotlight search field — a vendored equivalent of Axiom's private
 * `CommandInput`, built on the public `Input`. Renders a leading search icon
 * by default (override via `addonBefore`) and supports a trailing adornment
 * via `addonAfter`. Controlled through `value` / `onValueChange`.
 */
export const SpotlightInput = forwardRef<HTMLInputElement, SpotlightInputProps>(
  (
    {
      addonBefore = (
        <span className={styles.leadingIcon}>
          <IconSearch />
        </span>
      ),
      className,
      ...props
    },
    ref
  ) => (
    <Input
      addonBefore={addonBefore}
      autoFocus
      className={clsx(styles.input, className)}
      htmlSize={1}
      ref={ref}
      size="xl"
      {...props}
    />
  )
);

SpotlightInput.displayName = 'SpotlightInput';
